import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import GsStep from "../components/gsstep/gsstep"
import "./gettingstarted.module.css"

function GettingStarted() {
  const data = useStaticQuery(graphql`
    query {
        screen1: file(relativePath: { eq: "screenshots/createinventoryframed.png" }) {
        childImageSharp {
            fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
            }
        }
        }
        screen2: file(relativePath: { eq: "screenshots/inventoriesframed-1.png" }) {
        childImageSharp {
            fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
            }
        }
        }
        screen3: file(relativePath: { eq: "screenshots/createcontainerframed.png" }) {
          childImageSharp {
              fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
              }
          }
        }
        screen4: file(relativePath: { eq: "screenshots/containersframed.png" }) {
        childImageSharp {
            fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
            }
          }
        }
        screen5: file(relativePath: { eq: "screenshots/createitemframed.png" }) {
          childImageSharp {
              fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
              }
          }
        }
        screen6: file(relativePath: { eq: "screenshots/containerwithitemsframed.png" }) {
        childImageSharp {
            fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
            }
          }
        }
        screen7: file(relativePath: { eq: "screenshots/itemframed-1.png" }) {
          childImageSharp {
              fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
              }
          }
        }
        screen8: file(relativePath: { eq: "screenshots/locationframed.png" }) {
        childImageSharp {
            fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
            }
          }
        }
        screen9: file(relativePath: { eq: "screenshots/move1framedrepaired.png" }) {
          childImageSharp {
              fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
              }
          }
        }
        screen10: file(relativePath: { eq: "screenshots/itemsframed-1.png" }) {
        childImageSharp {
            fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
            }
          }
        }
        screen11: file(relativePath: { eq: "screenshots/move1framedrepaired.png" }) {
          childImageSharp {
              fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
              }
          }
        }
        screen12: file(relativePath: { eq: "screenshots/commonsframed-1.png" }) {
        childImageSharp {
            fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
            }
          }
        }
        screen13: file(relativePath: { eq: "screenshots/pdfframed.png" }) {
          childImageSharp {
              fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
              }
            }
          }
    }
    `)

  return (
    <Layout>
      <SEO title="Getting Started" />
      <h1>Getting Started</h1>
      <GsStep 
        text="First, create your 'inventory', fill in the fields and save it, then select it from the list of inventories" 
        screen1={data.screen1.childImageSharp.fluid}
        screen2={data.screen2.childImageSharp.fluid}
      />
      <GsStep 
        text="Second, create a 'container' in your 'inventory'. Think of a 'container' as a box or a drawer, something that contains other things. Note that the first level of an inventory is made only of containers and not items directly. You cant set a location for it" 
        screen1={data.screen3.childImageSharp.fluid}
        screen2={data.screen4.childImageSharp.fluid}
      />
      <GsStep 
        text="Third, create your 'item' inside a 'container', assign a measure and take a picture of it... If you like. You can assign an 'item' to a 'common'. Think of a 'common' as a species of an item, being the item the specimen" 
        screen1={data.screen5.childImageSharp.fluid}
        screen2={data.screen6.childImageSharp.fluid}
      />
      <GsStep 
        text="Note the information this app displays of your item depends on your input. You can set its location or else it will inherit the location of its parents containers if it is available" 
        screen1={data.screen7.childImageSharp.fluid}
        screen2={data.screen8.childImageSharp.fluid}
      />
      <GsStep 
        text="Later, you can MOVE your 'item' or 'container' to other 'container', just Long Press the item or container you want to move. At last browse to the place you want to move it and press the button at the bottom and select 'Move' on the menu" 
        screen1={data.screen9.childImageSharp.fluid}
        screen2={data.screen10.childImageSharp.fluid}
      />
      <GsStep 
        text="You can look at the list of items anytime and browse, even better if some of them are common to each other" 
        screen1={data.screen9.childImageSharp.fluid}
        screen2={data.screen10.childImageSharp.fluid}
      />
      <GsStep 
        text="From the screens above you can press the action button at the top and export the lists of items and commons to a PDF file you can share with anyone" 
        screen1={data.screen12.childImageSharp.fluid}
        screen2={data.screen13.childImageSharp.fluid}
      />
    </Layout>
  )
} 

export default GettingStarted